module.exports = __webpack_public_path__ + "img/bg.4670cd7a.png";